import React from 'react';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { ReactComponent as FooterLogo } from 'app/modules/web-shop/components/footer/FooterLogo.svg';
import {
  pages,
  AppBarPageModel,
} from 'app/modules/web-shop/components/appbar/data';
import {
  footerCss,
  appbarlinkcss,
  footerCopyrightCss,
  subscribeFormCss,
  footerAddressCss,
} from 'app/modules/web-shop/components/footer/style';
import { useEmailsignup } from 'app/hooks/useEmailSignup';

export function Footer() {
  const { email, handleSubmit, message, setEmail, setMessage } =
    useEmailsignup();

  return (
    <Box css={footerCss}>
      <Container
        maxWidth="lg"
        css={`
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        `}
      >
        <Grid
          container
          spacing={4}
          css={`
            height: 100%;
            @media (max-width: 768px) {
              display: block;
              max-width: 100%;

              > div {
                max-width: 100%;
              }
            }
          `}
        >
          <Grid item xs={4}>
            <FooterLogo />
          </Grid>

          <Grid item xs={2}>
            {pages.map((page: AppBarPageModel) => (
              <Link
                key={page.title}
                to={page.path}
                css={appbarlinkcss(window.location.pathname === page.path)}
              >
                {page.title}
              </Link>
            ))}
          </Grid>

          <Grid item xs={3} css={footerAddressCss}>
            <h5>
              The Open Data Company B.V. <br /> Papaverweg 34, <br /> 1032 KJ
              Amsterdam, <br />
              The Netherlands <br />
              Chamber of Commerce: 83103120
            </h5>

            <h5>
              Tel:{' '}
              <a href="tel:+31 20 503 9091" target="_blank" rel="noreferrer">
                +31 20 503 9091
              </a>
              <br />
              <a href="mailto:info@aida.tools" target="_blank" rel="noreferrer">
                info@aida.tools
              </a>
            </h5>
          </Grid>

          <Grid item xs={3} sm={12} md={3} css={subscribeFormCss}>
            <h5>Subscribe to our newsletter</h5>
            <div
              css={`
                display: flex;
              `}
            >
              <input
                type="text"
                value={email}
                placeholder="Email Address"
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (message) {
                    setMessage('');
                  }
                }}
              />
              <button type="button" onClick={handleSubmit}>
                Subscribe
              </button>
            </div>
            <h6>{message}</h6>
            <h6>
              You will receive occasional emails from AIDA. You always have the
              choice to unsubscribe within every email.
            </h6>
          </Grid>
        </Grid>

        <Grid container spacing={2} css={footerCopyrightCss}>
          <Grid item xs={12} md={12} lg={10}>
            ⓒ {new Date().getFullYear()} TODC All Rights Reserved
            <b
              css={`
                margin: 0 5px;
                font-size: 16px;
              `}
            >
              ·
            </b>
            Some images are derived from illustrations by{' '}
            <a
              href="https://www.figma.com/community/file/865151903316043704"
              target="_blank"
              rel="noreferrer"
            >
              Pavan Kondapuram
            </a>{' '}
            used under{' '}
            <a
              href="https://creativecommons.org/licenses/by/4.0/"
              target="_blank"
              rel="noreferrer"
            >
              CC BY 4.0
            </a>
            <b
              css={`
                margin: 0 5px;
                font-size: 16px;
              `}
            >
              ·
            </b>
            <a
              href="https://drive.google.com/file/d/1-WR29meEj97LpgdAHJ2LbALHgxab2o3N/view"
              className="privacy-link"
              target="_blank"
              rel="noreferrer"
            >
              Privacy
            </a>{' '}
            <a
              href="https://drive.google.com/file/d/1sIWPZwGHsJF_rxyOWtny8ZjJS_BU-SlM/view"
              className="privacy-link"
              target="_blank"
              rel="noreferrer"
            >
              Terms and conditions
            </a>{' '}
            <a
              href="https://drive.google.com/file/d/1XiUlzaVNAir4ZQ0PMWrXLKETI0JcNirt/view"
              className="privacy-link"
              target="_blank"
              rel="noreferrer"
            >
              Disclaimer
            </a>
          </Grid>

          <Grid
            item
            xs={12}
            md={12}
            lg={2}
            css={`
              gap: 1rem;
              display: flex;
              flex-direction: row;
              justify-content: flex-end;

              @media (max-width: 768px) {
                justify-content: flex-start;
              }
            `}
          >
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.youtube.com/channel/UCVdtb-qQ8JUn9eNPeQO0Raw"
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.2058 19.666L18.7138 17.57C18.3218 17.3881 17.9998 17.592 17.9998 18.026V21.9741C17.9998 22.4081 18.3218 22.612 18.7138 22.43L23.2038 20.334C23.5978 20.15 23.5978 19.85 23.2058 19.666ZM19.9998 0.800049C9.39581 0.800049 0.799805 9.39605 0.799805 20C0.799805 30.604 9.39581 39.2001 19.9998 39.2001C30.6038 39.2001 39.1998 30.604 39.1998 20C39.1998 9.39605 30.6038 0.800049 19.9998 0.800049ZM19.9998 27.8C10.1718 27.8 9.9998 26.914 9.9998 20C9.9998 13.0861 10.1718 12.2 19.9998 12.2C29.8278 12.2 29.9998 13.0861 29.9998 20C29.9998 26.914 29.8278 27.8 19.9998 27.8Z"
                  fill="white"
                />
              </svg>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/company/the-open-data-compagny/"
            >
              <svg width="40" height="40" viewBox="0 0 40 40">
                <path
                  d="M19.9998 0.799805C9.39581 0.799805 0.799805 9.39581 0.799805 19.9998C0.799805 30.6038 9.39581 39.1998 19.9998 39.1998C30.6038 39.1998 39.1998 30.6038 39.1998 19.9998C39.1998 9.39581 30.6038 0.799805 19.9998 0.799805ZM15.2998 27.9578H11.4118V15.4458H15.2998V27.9578ZM13.3318 13.9098C12.1038 13.9098 11.3098 13.0398 11.3098 11.9638C11.3098 10.8658 12.1278 10.0218 13.3818 10.0218C14.6358 10.0218 15.4038 10.8658 15.4278 11.9638C15.4278 13.0398 14.6358 13.9098 13.3318 13.9098ZM29.4998 27.9578H25.6118V21.0238C25.6118 19.4098 25.0478 18.3138 23.6418 18.3138C22.5678 18.3138 21.9298 19.0558 21.6478 19.7698C21.5438 20.0238 21.5178 20.3838 21.5178 20.7418V27.9558H17.6278V19.4358C17.6278 17.8738 17.5778 16.5678 17.5258 15.4438H20.9038L21.0818 17.1818H21.1598C21.6718 16.3658 22.9258 15.1618 25.0238 15.1618C27.5818 15.1618 29.4998 16.8758 29.4998 20.5598V27.9578Z"
                  fill="white"
                />
              </svg>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://twitter.com/theopendatacomp"
            >
              <svg width="40" height="40" viewBox="0 0 40 40">
                <path
                  d="M20 0C8.95536 0 0 8.95536 0 20C0 31.0446 8.95536 40 20 40C31.0446 40 40 31.0446 40 20C40 8.95536 31.0446 0 20 0ZM29.6116 15.0759C29.625 15.2857 29.625 15.5045 29.625 15.7188C29.625 22.2723 24.6339 29.8214 15.5134 29.8214C12.7009 29.8214 10.0938 29.0045 7.89732 27.5982C8.29911 27.6429 8.68304 27.6607 9.09375 27.6607C11.4152 27.6607 13.5491 26.875 15.25 25.5446C13.0714 25.5 11.2411 24.0714 10.6161 22.1071C11.3795 22.2188 12.067 22.2188 12.8527 22.0179C11.7309 21.79 10.7227 21.1807 9.99918 20.2937C9.2757 19.4066 8.88164 18.2965 8.88393 17.1518V17.0893C9.54018 17.4598 10.3125 17.6875 11.1205 17.7188C10.4413 17.266 9.88419 16.6527 9.49871 15.9332C9.11323 15.2136 8.91127 14.4101 8.91072 13.5938C8.91072 12.6696 9.15179 11.8259 9.58482 11.0938C10.8299 12.6265 12.3836 13.8801 14.1449 14.7731C15.9062 15.666 17.8358 16.1784 19.808 16.2768C19.1071 12.9063 21.625 10.1786 24.6518 10.1786C26.0804 10.1786 27.3661 10.7768 28.2723 11.7411C29.3929 11.5312 30.4643 11.1116 31.4196 10.5491C31.0491 11.6964 30.2723 12.6652 29.2411 13.2768C30.2411 13.1696 31.2054 12.8929 32.0982 12.5045C31.4241 13.4955 30.5804 14.375 29.6116 15.0759Z"
                  fill="white"
                />
              </svg>
            </a>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
